/**
 * Auth popup length check. Backend already accepts EE 7-digit numbers;
 * frontend historically required 12 chars (+7 + 10 digits).
 * +372 + 7 national digits = 11 chars without spaces (YT-24858).
 */
export function isAuthPhoneValid(phone) {
  const compact = String(phone || "").replace(/\s/g, "");
  if (!compact) {
    return false;
  }

  const minLength = compact.startsWith("+372") ? 11 : 12;
  return compact.length >= minLength;
}
